import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography, Alert, CircularProgress } from "@mui/material";
import { Form, Formik } from "formik";
import { Stack } from "@mui/system";
import DeleteIcon from "@mui/icons-material/Delete";

const DeActivateQuestions = ({ deactivateQuestions, question }) => {
  const [open, setOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
    setErrorMessage("");
  };

  const handleClose = () => {
    setOpen(false);
    setErrorMessage("");
  };

  // minimal payload structure for deactivation/activation
  const prepareSubmitData = (question) => {
    return {
      id: question.id,
      name: question.name || "Unnamed Question",
      active: !question.active,
      group_id: question.group_id,
      question_type: question.question_type || "",
      value: question.value || 0,
    };
  };

  // If we have no valid question data, render nothing or fallback UI
  if (!question || !question.id) {
    return (
      <Button variant="contained" color="error" disabled>
        Invalid Question
      </Button>
    );
  }

  return (
    <React.Fragment>
      {question.active ? (
        <Button
          size="small"
          style={{ borderRadius: "100px" }}
          variant="outlined"
          color="error"
          onClick={handleClickOpen}
        >
          <DeleteIcon />
        </Button>
      ) : (
        <Button variant="contained" onClick={handleClickOpen} color="primary">
          Activate
        </Button>
      )}

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {question.active ? "Deactivate Question" : "Activate Question"}
        </DialogTitle>
        <DialogContent>
          {errorMessage && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          )}

          <Formik
            initialValues={{
              ...question,
            }}
            onSubmit={async (values) => {
              try {
                const dataToSubmit = prepareSubmitData(values);

                if (!dataToSubmit) {
                  setErrorMessage("Invalid question data. Please try again.");
                  return;
                }

                console.log("Submitting data:", dataToSubmit);
                await deactivateQuestions.mutateAsync(dataToSubmit);
                handleClose();
              } catch (error) {
                console.error("Error in submission:", error);
                setErrorMessage(
                  error.response?.data?.message ||
                    error.message ||
                    "An error occurred while updating the question"
                );
              }
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <Typography variant="h6" gutterBottom>
                  {question.name || "Unnamed Question"}
                </Typography>
                <Typography color="GrayText" variant="body1" gutterBottom>
                  {question.active
                    ? "Are you sure you want to deactivate this question? It will be moved to the inactive questions section."
                    : "Are you sure you want to activate this question? It will be moved to the active questions section."}
                </Typography>

                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  spacing={2}
                  sx={{ mt: 3 }}
                >
                  <Button onClick={handleClose} disabled={isSubmitting}>
                    Cancel
                  </Button>
                  <Button
                    color={question.active ? "error" : "primary"}
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : question.active ? (
                      "Deactivate"
                    ) : (
                      "Activate"
                    )}
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default DeActivateQuestions;
